import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../lib/api-client";
import {ProductLine} from "../types/ProductLine";
import {ProductType} from "../types/ProductType";


export const useGetProductLines = (enabled: boolean = true) => {
    const { data, isLoading } = useQuery({
        queryKey: ['product-lines'],
        queryFn: async () => await apiClient.get('product/product-lines') as ProductLine[],
        enabled: enabled
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};


export const useGetProductTypes = (productCatalogID: number, productLineID: number, enabled: boolean = true) => {
    const { data, isLoading } = useQuery({
        queryKey: ['product-types', productCatalogID, productLineID],
        queryFn: async () => await apiClient.get('product/product-types', {
            params: {
                productCatalogID,
                productLineID
            }
        }) as ProductType[],
        enabled: enabled
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
